import React from 'react';

import { useIntl } from '@edx/frontend-platform/i18n';
import { Form, Icon } from '@edx/paragon';
import { ExpandMore } from '@edx/paragon/icons';
import PropTypes from 'prop-types';

import messages from '../register/messages';

const FormFieldRenderer = (props) => {
  const { formatMessage } = useIntl();

  let formField = null;
  const {
    className, labelClassName, errorMessage, fieldData, onChangeHandler, isRequired, value,
  } = props;

  const handleFocus = (e) => {
    if (props.handleFocus) { props.handleFocus(e); }
  };

  const handleOnBlur = (e) => {
    if (props.handleBlur) { props.handleBlur(e); }
  };

  switch (fieldData.type) {
    case 'select': {
      if (!fieldData.options) {
        return null;
      }
      formField = (
        <Form.Group controlId={fieldData.name} className="form-field form-type" isInvalid={!!(isRequired && errorMessage)}>
          <Form.Label className="label-text-small">{fieldData.label} ({formatMessage(messages['customized.courses.optional.label'])})</Form.Label>
          <Form.Control
            className={`form-group__form-field ${className}`}
            as="select"
            name={fieldData.name}
            value={value}
            aria-invalid={isRequired && Boolean(errorMessage)}
            onChange={(e) => onChangeHandler(e)}
            trailingElement={<Icon src={ExpandMore} />}
            onBlur={handleOnBlur}
            onFocus={handleFocus}
          >
            <option key="default" value=""> </option>
            {fieldData.name === 'city'
              ? fieldData.options.map((cityObj) => (
                <option key={cityObj.city} value={cityObj.city}>
                  {cityObj.city}
                </option>
              ))
              : fieldData.options.map((option) => (
                <option className="data-hj-suppress" key={option[0]} value={option[0]}>
                  {option[1]}
                </option>
              ))}
          </Form.Control>
          {isRequired && errorMessage && (
            <Form.Control.Feedback id={`${fieldData.name}-error`} type="invalid" className="form-text-size" hasIcon={false}>
              {errorMessage}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      );
      break;
    }
    case 'textarea': {
      formField = (
        <Form.Group controlId={fieldData.name} className="form-field form-type mb-3" isInvalid={!!(isRequired && errorMessage)}>
          <Form.Label className="label-text-small">{fieldData.label}</Form.Label>
          <Form.Control
            className={`form-group__form-field ${className}`}
            as="textarea"
            name={fieldData.name}
            value={value}
            aria-invalid={isRequired && Boolean(errorMessage)}
            onChange={(e) => onChangeHandler(e)}
            onBlur={handleOnBlur}
            onFocus={handleFocus}
          />
          {isRequired && errorMessage && (
            <Form.Control.Feedback id={`${fieldData.name}-error`} type="invalid" className="form-text-size" hasIcon={false}>
              {errorMessage}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      );
      break;
    }
    case 'text': {
      formField = (
        <Form.Group controlId={fieldData.name} className="form-field form-type mb-3" isInvalid={!!(isRequired && errorMessage)}>
          <Form.Label className="label-text-small">{fieldData.label}</Form.Label>
          <Form.Control
            className={`form-group__form-field ${className}`}
            name={fieldData.name}
            value={value}
            aria-invalid={isRequired && Boolean(errorMessage)}
            onChange={(e) => onChangeHandler(e)}
            onBlur={handleOnBlur}
            onFocus={handleFocus}
          />
          {isRequired && errorMessage && (
            <Form.Control.Feedback id={`${fieldData.name}-error`} type="invalid" className="form-text-size" hasIcon={false}>
              {errorMessage}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      );
      break;
    }
    case 'checkbox': {
      formField = (
        <Form.Group isInvalid={!!(isRequired && errorMessage)}>
          <div className={`form-field ${fieldData.name}`}>
            <input
              id={fieldData.name}
              type="checkbox"
              className={`input-block checkbox ${className}`}
              checked={!!value}
              name={fieldData.name}
              value={value}
              aria-invalid={isRequired && Boolean(errorMessage)}
              onChange={(e) => onChangeHandler(e)}
              onBlur={handleOnBlur}
              onFocus={handleFocus}
            />
            <span className={`custom-checkbox ${errorMessage && 'unchcked-error'}`}/>
            <label htmlFor={fieldData.name} className={`checkbox-label ${labelClassName}`}>
              <span className={`responsive-text ${errorMessage && 'invalid-red-color'}`}>
                {fieldData.label}
              </span>
            </label>
          </div>
        </Form.Group>
      );
      break;
    }
    default:
      break;
  }

  return formField;
};

FormFieldRenderer.defaultProps = {
  className: '',
  labelClassName: '',
  value: '',
  handleBlur: null,
  handleFocus: null,
  errorMessage: '',
  isRequired: false,
};

FormFieldRenderer.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  fieldData: PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    name: PropTypes.string,
    options: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)), // array of arrays of strings
      PropTypes.arrayOf(PropTypes.object), // array of objects
    ]),
  }).isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func,
  errorMessage: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object,
  ]),
};

export default FormFieldRenderer;
